namespace $.$$ {
	export class $exso_sheets_blowings_class extends $.$exso_sheets_blowings_class {
		@$mol_mem_key
		parse(data: Record<keyof $exso_sheets_blowing, string>) {
			return {
				place: data.place,
				block: data.block,
				mesh: data.mesh,
				burnt: parseFloat(data.burnt),
				blasted: parseFloat(data.blasted),
				state: (this.state() as any)[data.state],
				date: new $mol_time_moment(data.date),
				id: [data.place, data.date, data.block].join('/'),
			} satisfies $exso_sheets_blowing
		}
	}
	export const $exso_sheets_blowings = new $exso_sheets_blowings_class() as any as $exso_sheets<$exso_sheets_blowing>
}
